import type { FaireProductEntity } from "../../entity_types/product";

export const p_juv9un87jy: FaireProductEntity = {
  token: "p_juv9un87jy",
  type: "product",
  name: "Thank You Kindly Card",
  brandToken: "b_v392u5bk7d",
  brandName: "Wallflower Paper & Party",
  imageUrl:
    "https://cdn.faire.com/fastly/eab961457688bc61a37660864c3a755940ea231893664ef780615bc7cf13c80d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2cfc1afaf1eeda1171f883c789c05b1bde97cd1fe048afb9cba966e8d83d6d89.jpeg",
  ],
  priceDollars: 2.75,
  description:
    'Wild West Kitty tips his cowboy hat and strides away into the setting sun, thanking you for a day of ropin’ and ridin’! Or perhaps you just had him over for dinner. Either way, thank you kindly! Front text reads: “Thank you kindly!”Perfect for thanking customers, friends, teachers, hosts, neighbors, or anyone who deserves a little western-inspired gratitude.\n\nProduct Details:\nA2 folded greeting card (4.25" × 5.5")\nBlank inside\nPremium eggshell cardstock\nPrinted in the USA\nPaired with a coordinating envelope\nPackaged in a protective cello sleeve',
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:36.945Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
